export enum BulkUpdateType {
    MoveToFolder,
    AddToTeam,
    UpdateType,
    UpdateJob,
    Archive,
    RemoveFromTeam,
    RemoveAssociatedJob
}

export type BulkUpdateEntry = {
    id: string;
    isPerson: boolean;
};
